import { useCallback, useEffect, useState } from 'react'
import { hideLoader, showLoader, trimLocation, useInstance } from '@10000/react'
import { InputScreen, useBackground, useShell, useStack } from '../layout'
import { Body, Box, Button, Google } from '../widgets'
import { Password, Submit, Text } from '../forms'
import { ForgotPassword, SignUp } from '.'
import { PasswordSetUp } from '../onboarding'
import { authenticate, authRedirectUri } from './request.js'
import { query } from '../../utilities'

export const Authenticate = ({ active }) => {
  const { push, replaceStack } = useStack()
  const { setInstance } = useInstance()
  const { username, temporaryPassword } = query()
  const [autoLogin, setAutoLogin] = useState(Boolean(username && temporaryPassword))

  useBackground().set(mobile => ({ active, background: (mobile || autoLogin) ? null : 2, fade: true }))
  useShell({ active, mode: autoLogin ? 'none' : 'navigate' })

  const login = useCallback(({ username, password }) => {
    return authenticate({ username, password }).then(res => {
      const { success, challenge, user } = res
      if(success) {
        setInstance({ id: user.tenantId, region: user.region })
      } else if (challenge) {
        if(challenge.type === 'NEW_PASSWORD_REQUIRED') {
          replaceStack(PasswordSetUp, { props: {
            challenge: challenge.type,
            session: challenge.session,
            username: challenge.username,
            allowLinking: true
          } })
        }
      }
    })
  }, [replaceStack, setInstance])

  useEffect(() => {
    if(autoLogin) {
      showLoader()
      // browsers replace + with a space, email addresses can't contain spaces - change spaces back to +
      login({ username: username.replace(/ /g, '+'), password: temporaryPassword })
        .finally(() => {
          hideLoader()
          trimLocation()
          setAutoLogin(false)
        })
    }
  }, [login, autoLogin, username, temporaryPassword])

  return (!autoLogin &&
    <InputScreen centered onSubmit={login} title="Welcome">
      <Box fullWidth gap={8} column alignItems="center">
        <Text
          title="Email"
          name="username"
          type="email"
          required
        />
        <Password />
        <Box fullWidth justifyContent="flex-start">
          <a onClick={() => push(ForgotPassword)}>Forgot password? Don&apos;t have one?</a>
        </Box>
      </Box>

      <Box className="fit-button-to-container" fullWidth>
        <Submit fullWidth>Log in</Submit>
      </Box>

      <Box fullWidth alignItems="center" justifyContent="space-between">
        <Box width="40%" height={1} background="white" />
        <Body>or</Body>
        <Box width="40%" height={1} background="white" />
      </Box>

      <Box gap={8} fullWidth>
        <Button
          fullWidth
          onClick={() => window.location.href = authRedirectUri('AP', 'Google')}
        >
          <Google />
        </Button>
      </Box>

      <Box gap={4} alignItems="center">
        <Body>
          New to Shivoo?
        </Body>
        <a onClick={() => push(SignUp)}>Sign-up</a>
      </Box>
    </InputScreen>
  )
}
